module.exports = __webpack_public_path__ + "static/man-raising-hand-yellow-e8425398216a72ad6782ac0c9604a635.png";